const dataTypeUser = {
    RH: { codigo: 3, nome: 'RH' },
    MCE: { codigo: 7, nome: 'MCE' },
};

function splitCellphone(cellphone) {
    return cellphone.replace(/\(|\)/g, '').split(' ');
}

export default function createPayloads(dataForm, type, contract) {
    const [ddd, numero] = splitCellphone(dataForm.cellphone.value);

    const payloadContato = {
        contract,
        NomeContato: dataForm.fullName.value,
        NomeCargoContato: dataForm.position.value,
        DataNascimentoContato: dataForm.birthUser.value,
        TiposClassificacoes: [
            {
                CodigoTipoClassificacao: dataTypeUser[dataForm.typeUser.value].codigo,
                DescricaoTipoClassificacao: dataTypeUser[dataForm.typeUser.value].nome,
            },
        ],
        DddCelular: ddd,
        NumeroCelular: numero,
        DddTelefone: '',
        NumeroTelefone: '',
        NumeroRamal: '',
        EmailContato: dataForm.email.value,
        EnviaEmailMovimentacaoCadastral: true,
    };

    const [nome, ...sobrenomes] = dataForm.fullName.value.split(' ');

    const payloadPerfil = {
        email: dataForm.email.value,
        contrato: contract,
        Nome: nome,
        Sobre_nome: sobrenomes.join(' '),
        cpfOuCnpj: '',
        telefone: dataForm.cellphone.value,
        cidade: '',
        bairro: '',
        numero: '',
        datanascimento: dataForm.birthUser.value,
        cargo: dataForm.position.value,
        permissoes:
            dataForm.typeUser.value === 'RH'
                ? [{ id: '8' }]
                : dataForm.permissions.value.map((permission) => ({ id: permission })),
        acessoConcedidoPor: 'PEDRO',
    };

    let payloadRemoverPerfil = {};

    if (type === 'edit') {
        payloadRemoverPerfil = { email: dataForm.email.value, contrato: contract };
    }

    return { payloadContato, payloadPerfil, payloadRemoverPerfil };
}
